import { unitDisplayName } from './unitsManager';
import { loadFieldRecords } from './fieldManager';
const daysjs = require('../utils/dayjsConfig');
const DAY = 60 * 60 * 24;

const TYPE_UNITS = {
  plan_irr: 'length',
  plan_fert: 'weight/area',
  plan_hcl: 'volume',
  plan_hpo: 'volume',
  plan_note: '',
};

export const waterTreatmentDisplayName = {
  hpo: 'HPO',
  cs: 'Copper Sulphate',
  sanidate: 'SaniDate',
  acid: 'Acid',
};

export const plannerType = Object.freeze({
  DAILY_RECOMMENDATION: 'daily_recommendation',
  WEEKLY_RECOMMENDATION: 'weekly_recommendation',
  DISABLED: 'disabled',
});

export const weeklyPlannerModes = Object.freeze({
  WEEKLY: 'weekly',
  INTERVAL: 'interval',
});

export var sumEventsValues = (items, date, durationInDays) => {
  let total = {};
  items &&
    Object.keys(items).forEach(type => {
      let sumAmount = 0;
      let sumEvents = 0;

      items[type] &&
        Object.keys(items[type]).forEach(item => {
          if (
            daysjs.unix(date).isSameOrBefore(daysjs.unix(Number(item))) &&
            daysjs
              .unix(Number(item))
              .isBefore(daysjs.unix(date + durationInDays * DAY))
          ) {
            sumAmount +=
              type === 'plan_note'
                ? 1
                : Number(items[type][item].value) || Number(items[type][item]);
            sumEvents += 1;
          }
        });
      total[type] = { sumAmount: sumAmount, sumEvents: sumEvents };
    });
  return total;
};

export var getPlannerItems = (fieldId, userData, setPlans) => {
  // Load all coming plans for current field
  loadFieldRecords(
    fieldId,
    0,
    ['plan_irr', 'plan_fert', 'plan_hpo', 'plan_hcl', 'plan_note', 'plan_wtr'],
    ['endDate/type', 'fertType/source/nitroAmount', '', '', '', 'endDate/type']
  ).then(function (res) {
    let loadedPlans = [];

    for (const [planType, planObjects] of Object.entries(res)) {
      for (const [startDate, values] of Object.entries(planObjects['values'])) {
        let tmpDict = {};
        tmpDict['planType'] = planType;
        tmpDict['startDate'] = startDate;
        tmpDict['sortDate'] = startDate;

        if (typeof values === 'object') {
          if ('type' in values && values['type'] === 'filler') {
            // filler value used for fill accumulated graph only , will not apper in "coming up" section and planning
            continue;
          }
          tmpDict = Object.assign({}, tmpDict, values);
          tmpDict['value'] =
            parseFloat(parseFloat(tmpDict['value']).toFixed(4)) / 1;

          if ('endDate' in values) {
            tmpDict['sortDate'] = values['endDate'];
            tmpDict['duration'] = (
              (parseFloat(values['endDate']) - parseFloat(startDate)) /
              (60 * 60)
            ).toFixed(1);
          }
          if ('fertType' in values) {
            tmpDict['fertType'] = values['fertType'];
          }
        } else {
          tmpDict['value'] = values;
        }
        if (userData) {
          if (planType === 'plan_wtr') {
            let wtrUnits = getUnitsForWTRType(values.type);
            tmpDict['units'] = userData[wtrUnits];
            tmpDict['note'] =
              values.type === 'cs'
                ? 'WT_timing_recommendation_after_irrigation_starts'
                : 'WT_timing_recommendation_last_hour';
          } else {
            let unit = TYPE_UNITS[planType];
            tmpDict['units'] =
              userData && unit in userData
                ? unitDisplayName(userData[unit])
                : unit;
          }
          loadedPlans.push(tmpDict);
        }
      }
    }

    // Sorting by sortDate which a parameter that holds the start date for value only params and the end
    // date for params with start and end dates
    loadedPlans.sort(function (a, b) {
      return a.sortDate - b.sortDate;
    });
    if (setPlans) {
      setPlans(loadedPlans);
    }
  });
};

export function getUnitsForWTRType(wtrType) {
  if (['cs'].includes(wtrType)) {
    return 'weight';
  }
  return 'small_volume';
}

// Robustly parse weekKey (UNIX seconds or ISO string)
export function parseDateInput(dateInput) {
  if (typeof dateInput === 'number' || /^\d+$/.test(dateInput)) {
    return new Date(Number(dateInput) * 1000);
  }
  return new Date(dateInput);
}

export function FromDateToStringFormat(dateInput) {
  const date =
    dateInput instanceof Date ? dateInput : parseDateInput(dateInput);
  if (isNaN(date.getTime())) return '-';
  return date.toLocaleDateString('en-GB', { day: 'numeric', month: 'short' });
}

// The recommendations API returns the weeks in chronological order centered on
// the current week: [previous, current, next]. The current week is therefore
// the MIDDLE element — do NOT derive it from `local_midnight_week_start` dates,
// which are local midnight in the FIELD's timezone and mis-bucket against the
// browser clock for fields whose timezone is behind the browser's.
export function getThisWeekIndex(weekKeys) {
  if (!weekKeys || weekKeys.length === 0) return 0;
  return Math.floor((weekKeys.length - 1) / 2);
}

// Returns 'this', 'previous', or 'next' based on weekIdx and thisWeekIdx
export function getWeekType(weekIdx, thisWeekIdx) {
  if (weekIdx < thisWeekIdx) return 'previous';
  if (weekIdx > thisWeekIdx) return 'next';
  return 'this';
}

// Maps week types to their corresponding translation keys
export function getWeekTypeDisplayName(weekType) {
  const weekTypeMap = {
    this: 'new_planner_this_week',
    next: 'new_planner_next_week',
    previous: 'new_planner_previous_week',
  };
  return weekTypeMap[weekType] || '';
}
